import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToNumber from 'utils/converters/fromAnyToNumber.util';
import fixed from 'utils/values/fixed.util';

const DECIMALS = /\.?\d*$/;

const isPrice = (value) => {
  if (Array.isArray(value)) {
    return false;
  }

  const number = fromAnyToNumber(value);
  if (!Number.isFinite(number)) {
    return false;
  }

  return fromAnyToBool(fixed(number).match(DECIMALS));
};

// noinspection JSUnusedGlobalSymbols
export default isPrice;
